export { default as theme } from 'prismjs/themes/prism-dark.css';
